export const parseResponseText = (text?: string | null): object | null => {
  try {
    return (JSON.parse(text as string) as object) || null;
  } catch {
    return null;
  }
};

const hideEformsIdFromUrl = (url: string): string =>
  url.replace(/\/(\w{8})-(\w{4})-(\w{4})-(\w{4})-(\w{12})\/?/g, '/<eformId>/');

const hideFieldsIdFromUrl = (url: string): string =>
  url.replace(/\/(\w{32})\/?/g, '/<filedId>/');

const hideIdFromUrl = (url: string): string => url.replace(/\/(\w{22})\/?/g, '/<id>/');

interface EndpointInfo {
  endpoint: string;
  searchParams?: Array<[key: string, value: string]>;
}

export const parseEndpoint = (rawUrl: string): EndpointInfo => {
  try {
    const url = new URL(rawUrl);
    const endpoint =
      url.host + hideEformsIdFromUrl(hideIdFromUrl(hideFieldsIdFromUrl(url.pathname)));
    const result: EndpointInfo = { endpoint };

    if (url.searchParams.toString()) {
      result.searchParams = [...url.searchParams];
    }

    return result;
  } catch (err) {
    return {
      endpoint: `unknown endpoint`,
      searchParams: [['<rawUrl>', rawUrl]],
    };
  }
};
